import { IAction } from '../utils';
import { reducerTypes } from './types';

export interface ICurrencyReducer {
  selectedCurrency: string;
  currency: { id: string; label: string }[];
  currencyRate: number;
}

const INITIAL: ICurrencyReducer = {
  selectedCurrency: `${typeof window !== 'undefined' ? sessionStorage?.getItem('selected-currency') || 'EUR' : 'EUR'}`,
  currency: [
    { id: 'USD', label: 'USD' },
    { id: 'EUR', label: 'EUR' },
  ],
  currencyRate: 1,
};

export const currencyReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
    case reducerTypes.SET_SELECTED_CURRENCY:
      sessionStorage.setItem('selected-currency', payload);
      return { ...state, selectedCurrency: payload };
    case reducerTypes.GET_CURRENCIES:
      return {
        ...state,
        currency: payload.data.map((item: string) => ({
          id: item,
          label: item,
        })),
      };
    case reducerTypes.GET_CURRENCY_RATE:
      return { ...state, currencyRate: payload.data };
    default:
      return state;
  }
};
